import React from 'react';
import type { Priority } from '@/lib/mockData';

interface PriorityBadgeProps {
  priority: Priority;
  size?: 'sm' | 'md';
}

export default function PriorityBadge({ priority, size = 'md' }: PriorityBadgeProps) {
  const classMap: Record<Priority, string> = {
    High: 'priority-badge-high',
    Medium: 'priority-badge-medium',
    Low: 'priority-badge-low',
  };

  return (
    <span className={`${classMap[priority]} ${size === 'sm' ? 'text-[10px] px-1.5' : ''}`}>
      {priority}
    </span>
  );
}